<template>
  <div class="widget-card widget-sales">
    <v-card class="widget-card__card" height="100%">
      <v-card-title class="primary white--text widget-card__card-title">
        Продажи
      </v-card-title>
      <v-card-text class="widget-card__card-text pt-3">
      </v-card-text>
      <v-card-actions class="pa-3 widget-card__card-actions widget-sales__actions" bottom>

        <v-btn block color="default" to="/sale-form/new/new" class="mb-3 widget-card__actions-btn" v-if="isDealer && isPeriodOpen && user.role_settings.modules_has_sales">
          <v-icon>mdi-checkbox-multiple-marked-circle-outline</v-icon>
          <span class="pl-4">Регистрация продажи</span>
        </v-btn>
        <v-banner  v-if="isDealer && !isPeriodOpen"> <span class="pl-4">Период закрыт</span></v-banner>

        <v-btn block color="default" to="/sales" class="ml-0 widget-card__actions-btn" v-if="user.role_settings.modules_has_sales_list">
          <v-icon>mdi-playlist-check</v-icon>
          <span class="pl-4">История продаж</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['user'],
  computed: {
    isManager() { return this.$store.getters.isManager; },
    isDealer() { return this.$store.getters.isDealer; },
    isPeriodOpen() { return this.$store.getters.isPeriodOpen; },
  },
  methods: {
    CloseSales() { this.$store.dispatch('ShowError', 'Уважаемые участники, внесение продаж приостановлено, в связи с окончанием программы лояльности "Клуб Профессионалов"'); },
  },
};
</script>

<style lang="scss">
.widget-sales {
  &__actions {
    flex-direction: column;
  }
}
</style>
